module.exports = __webpack_public_path__ + "img/2-up.d4463cae.png";